
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */
import Code from 'components/Code'
import Table, { Row, Column } from 'components/Table'


const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <h3><inlineCode parentName="h3">{`keyframes`}</inlineCode>{` | web-only`}</h3>
    <p>{`A helper method to create keyframes for animations.`}</p>
    <Table head={['Arguments', 'Description']} mdxType="Table">
  <Row mdxType="Row">
    <Column mdxType="Column">
      1. <Code mdxType="Code">TaggedTemplateLiteral</Code>
    </Column>
    <Column mdxType="Column">A tagged template literal with your keyframes inside.</Column>
  </Row>
    </Table>
    <p>{`Returns a Keyframes model, to be used in your animation declarations. You can use the `}<inlineCode parentName="p">{`getName()`}</inlineCode>{` API on the returned model if you wish to obtain the generated animation name.`}</p>
    <blockquote>
      <p parentName="blockquote">{`In styled-components v3 and below, the `}<inlineCode parentName="p">{`keyframes`}</inlineCode>{` helper directly returned the animation name instead of an object with the `}<inlineCode parentName="p">{`getName`}</inlineCode>{` method.`}</p>
    </blockquote>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`import styled, { keyframes } from 'styled-components'

const fadeIn = keyframes\`
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
\`

const FadeInButton = styled.button\`
  animation: 1s \${fadeIn} ease-out;
\`
`}</code></pre>
    <p>{`If you are composing your style rule as a partial, make sure to use the `}<inlineCode parentName="p">{`css`}</inlineCode>{` helper.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`import styled, { css, keyframes } from 'styled-components'

const pulse = keyframes\`
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
\`

const animation = props =>
  css\`
    \${pulse} \${props.animationLength} infinite alternate;
  \`

const PulseButton = styled.button\`
  animation: \${animation};
\`
`}</code></pre>
    <p>{`You can learn more about using animations with styled-components in the `}<a parentName="p" {...{
        "href": "/docs/basics#animations"
      }}>{`Animations`}</a>{` section.`}</p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;